import deepmerge from 'deepmerge';
import { DeepPartial } from '@/interfaces';
import config, { FragmentConfiguration as ConfigProps } from './default';

export interface FragmentConfiguration extends ConfigProps {}

export const tenantConfig: DeepPartial<FragmentConfiguration> = {
  addToWishlistButton: {
    iconFillColor: 'secondary',
  },
  api: {
    clientHost: 'https://www.universal.at',
    clientHostStaging: 'https://universalat.empirie.dev',
    enabled: true,
    values: {
      apiAddToBasketESI:
        '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/<device>/EUR/Basket-AddProduct?PageletId=comp.master.empiriecom.modalbox.item.PDVBuyboxAddProduct&ajaxContent=true&SKU=<sku>&QuantityValue=<quantity>&QuantityUnit=<quantityUnit>&ConfigurationString=<configString>&ServiceProductSKUs=<services>&SourceShopName=<shopname>&SourceShopPath=<shoppath>',
    },
  },
  articleServices: {
    articleServicesEndpoint: '/ems/v1/saa/map/<language>/<ordernumber>/<price>',
    serviceIconUrl: '//bilder.universal.at/i/empiriecom/<serviceicon>?$serviceIcon$',
    serviceModalUrl:
      '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/-/EUR/ViewServiceInfo-Start?ServiceUUID=<serviceuuid>&Headline=<headline>&Icon=<serviceicon>&ajaxContent=true',
  },
  company: {
    id: 'universalat',
    name: 'Universal',
    seoTitleName: 'Universal.at',
  },
  companyId: 'universalat',
  customerRatings: {
    enabled: true,
    iconColor: '#e1929e',
    iconType: 'STAR',
    values: {
      helpful:
        '/INTERSHOP/rest/WFS/EmpirieCom-UniversalAT-Site/-;loc=de_AT;cur=EUR/rating/feedback/<reviewid>/<action>',
      ratingPaginationURL:
        '/INTERSHOP/rest/WFS/EmpirieCom-UniversalAT-Site/-;loc=de_AT;cur=EUR/rating/<productid>/count/<startcount>/<endcount>',
      submitRatingURL:
        '/INTERSHOP/rest/WFS/EmpirieCom-UniversalAT-Site/-;loc=de_AT;cur=EUR/rating/new',
      summary:
        '/INTERSHOP/rest/WFS/EmpirieCom-UniversalAT-Site/-;loc=de_AT;cur=EUR/rating/<productid>/seo',
      termsESI:
        '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/<device>/EUR/RenderPagelet-Start?PageletId=comp.master.empiriecom.rating.TermsAndConditions',
    },
  },
  dynamicYieldEnabled: true,
  expressService: {
    apiEndpointUrl: '/api/deliverydate?tenant=universalat&date=<timestamp>',
    modalContent:
      '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/<device>/EUR/RenderPagelet-RenderInclude?IncludeID=include.productdetail.CMSIncludes.pagelet2-include.productdetail.CMSIncludes&ElementName=24hlayer&ajaxContent=true',
  },
  externalServices: {
    cliplister: {
      customerId: '86453',
    },
    grover: {
      apiKey:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdG9yZV9jb2RlIjoidW5pdmVyc2FsX29ubGluZSJ9.kOQ4smklidwIruHdCOIyUjD3DtER0VZpFHJrfabS3Gk',
      enabled: true,
    },
    loadbee: {
      apiKey: 'gLeVLPKhY3fETb4Zt8eradw5e5dh7Ewe',
    },
  },
  installmentCalculator: {
    cardLayout: true,
    hasSmallPrize: false,
    useExtendedLabel: false,
    useLargeLinkText: true,
  },
  page: {
    values: {
      defaultLocale: 'de-AT',
      locales: [
        {
          locale: 'de-AT',
          prefix: '',
        },
      ],
    },
  },
  price: {
    layout: 'detailViewBasePrimary',
  },
  specialHint: {
    enabled: false,
    esiUrl:
      '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/web/EUR/RenderPagelet-Start?PageletId=comp.master.empiriecom.PDVCoronaHintModalboxElement&ProductRef=8279945992-48-916793044%40EmpirieCom-UniversalAT&CatalogCategoryID=&CatalogID=&ajaxContent=true',
    hintLevel: 'warning',
  },
  taxHint: {
    modalContent: {
      default: {
        link:
          '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/web/EUR/RenderPagelet-RenderInclude?IncludeID=include.productdetail.CMSIncludes.pagelet2-include.productdetail.CMSIncludes&ElementName=shippinglayer&ajaxContent=true',
      },
      l: {
        link:
          '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/web/EUR/RenderPagelet-RenderInclude?IncludeID=include.productdetail.CMSIncludes.pagelet2-include.productdetail.CMSIncludes&ElementName=speditionlayer&ajaxContent=true',
      },
      s: {
        link:
          '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/web/EUR/RenderPagelet-RenderInclude?IncludeID=include.productdetail.CMSIncludes.pagelet2-include.productdetail.CMSIncludes&ElementName=speditionlayer&ajaxContent=true',
      },
    },
  },
  tracking: {
    schemaOrgOrganisation: {
      areaServed: 'AT',
      email: 'service@universal.at',
      hoursAvailable: '7 Tage die Woche auch an Wochenenden und Feiertagen von 7 - 22 Uhr',
      logo:
        'https://www.universal.at/INTERSHOP/static/WFS/EmpirieCom-UniversalAT-Site/web/EmpirieCom-UniversalAT/de_AT/2020/UVS_Logo_2017.svg',
      name: 'Universal',
      productSupported: '',
      sameAs: [
        '"https://www.pinterest.com/universal1/"',
        '"https://www.facebook.com/UniversalVersand"',
        '"https://www.youtube.com/user/UniversalVersand1"',
      ],
      telephone: '+43-662-4485-8',
      url: 'https://www.universal.at',
    },
    values: {
      brOutcomeUrl:
        '/INTERSHOP/web/WFS/EmpirieCom-UniversalAT-Site/de_AT/<device>/EUR/SendOutcomesForBusinessRuleEngine-BusinessRuleOutcomePDV',
      googleSiteVerification: 's2QUnwdvTe-7ynyeA5_mieNSFv5fBht-tPHc8U2_BOs',
      msvalidate01: '4067315BE5669CD6C74BDEC6F6AC5D47',
      siteName: '@EmpirieCom-UniversalAT',
      soastaId: 'VCRLH-5E9R4-TT9EZ-675H5-A9TNA',
    },
  },
};

export default deepmerge(config, tenantConfig);
